import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { langs } from './utils/languageUtils.js';

const loaders = {
    en: async () => import('./locales/en.js'),
    es: async () => import('./locales/es.js'),
    pt: async () => import('./locales/pt.js'),
};
const pending = new Map();

export function detectLang(pathname) {
    const parts = pathname.split('/');
    if (langs.includes(parts[1])) return parts[1];
    if (parts[1] === 'blog' && langs.includes(parts[2])) return parts[2];
    return 'en';
}

// No fallback language on either side: the browser holds only the page's language, so a key the
// prerender filled from another one would not hydrate.
function init(lng, resources) {
    if (i18n.isInitialized) return;
    void i18n.use(initReactI18next).init({ fallbackLng: false, supportedLngs: langs, lng, resources });
}

export function initI18nWithResources(resources) {
    init('en', resources);
}

export async function loadLanguage(lang) {
    if (i18n.isInitialized && i18n.hasResourceBundle(lang, 'translation')) return;
    if (!pending.has(lang)) {
        pending.set(
            lang,
            loaders[lang]().then(({ translation }) => {
                if (i18n.isInitialized) i18n.addResourceBundle(lang, 'translation', translation);
                else init(lang, { [lang]: { translation } });
            }),
        );
    }
    try {
        await pending.get(lang);
    } catch (error) {
        pending.delete(lang);
        throw error;
    }
}

export const initI18n = (location) => {
    if (!i18n.isInitialized) throw new Error('i18n used before its language was loaded');
    const lang = detectLang(location.pathname);
    if (i18n.language !== lang) void i18n.changeLanguage(lang);
    return i18n;
};
